<template>
  <div :class="$style.container">
    <router-link to="/new-message">
      <button class="btn">New Message</button>
    </router-link>
  </div>
</template>

<script>
  export default {

  }
</script>

<style module lang="less" src="./new-message-button.less"></style>



// WEBPACK FOOTER //
// new-message-button.vue?85bdaea8